import { LuArrowUpDown } from "react-icons/lu";
import { cn } from "@/lib/utils";
import {
  SqDropdownMenu,
  SqDropdownMenuContent,
  SqDropdownMenuItem,
  SqDropdownMenuTrigger,
} from "@/components/squircle-ui/dropdown";
import {
  SqTooltip,
  SqTooltipContent,
  SqTooltipProvider,
  SqTooltipTrigger,
} from "@/components/squircle-ui/tooltip";
import { CheckIcon } from "@radix-ui/react-icons";

export type SortByType = "newest" | "oldest" | "running_days" | "impressions";

type Props = {
  selectedType: SortByType;
  onChange: (type: SortByType) => void;
  className?: string;
  disabled?: boolean;
  isImpressionSortDisabled?: boolean;
};

const sortByLabels = {
  newest: "Newest",
  oldest: "Oldest",
  running_days: "Longest Running",
  impressions: "Impressions: high to low",
};

const SortByDropdown = ({
  selectedType,
  onChange,
  disabled,
  isImpressionSortDisabled,
  className,
}: Props) => {
  return (
    <SqDropdownMenu>
      <SqDropdownMenuTrigger
        disabled={disabled}
        className={cn(
          "w-auto h-8 px-[14px] py-[6px] gap-[6px]",
          className,
        )}
        hasOutline
        shadow="sm"
      >
        <div className="flex items-center gap-[6px]">
          <LuArrowUpDown
            size={14}
            strokeWidth={1}
            className="text-brand-primary-400 shrink-0"
          />
          <span className="mt-[1px] text-[11px] text-brand-primary-800 font-normal leading-[19.157px] tracking-[0.24px]">
            {sortByLabels[selectedType]}
          </span>
        </div>
      </SqDropdownMenuTrigger>
      <SqDropdownMenuContent align="start" radius={8}>
        <SqTooltipProvider>
          {(Object.entries(sortByLabels) as [SortByType, string][]).map(
            ([value, label]) => {
              const isDisabledItem =
                value === "impressions" && isImpressionSortDisabled;

              if (isDisabledItem) {
                return (
                  <SqTooltip key={value}>
                    <SqTooltipTrigger asChild>
                      <div className="h-7 relative flex w-full cursor-not-allowed select-none items-center squircle squircle-radius-[6px] px-2 py-1.5 text-[12px] text-brand-primary-new font-normal leading-[19.157px] tracking-[0.24px] opacity-50">
                        {label}
                      </div>
                    </SqTooltipTrigger>
                    <SqTooltipContent side="right" sideOffset={8} portal={true}>
                      <p>
                      Select only one brand to enable impression sorting
                      </p>
                    </SqTooltipContent>
                  </SqTooltip>
                );
              }

              return (
                <SqDropdownMenuItem
                  key={value}
                  className="text-[12px] text-brand-primary-new font-normal leading-[19.157px] tracking-[0.24px]"
                  onClick={() => {
                    if (value !== selectedType) {
                      onChange(value);
                    }
                  }}
                >
                  <span className="flex-1">{label}</span>
                  {value === selectedType && (
                    <CheckIcon className="h-4 w-4 ml-auto" />
                  )}
                </SqDropdownMenuItem>
              );
            },
          )}
        </SqTooltipProvider>
      </SqDropdownMenuContent>
    </SqDropdownMenu>
  );
};

export default SortByDropdown;
